export { default as ProductViewDeliveryInfo } from './ProductViewDeliveryInfo'
